import { rufe } from './client';

/** Der Widerruf im Haus (LEG-15 bis LEG-17, Paket 8 G). */
export type Widerrufsweg = 'widerrufsseite' | 'mail' | 'brief' | 'telefonisch_nachgereicht';

export const WEGNAME: Readonly<Record<Widerrufsweg, string>> = {
  widerrufsseite: 'Widerrufsseite',
  mail: 'E-Mail',
  brief: 'Brief',
  telefonisch_nachgereicht: 'telefonisch, in Textform nachgereicht',
};

export type Widerruf = {
  readonly id: string;
  readonly buchung: string;
  readonly buchungsnummer: string;
  readonly kunde: string;
  readonly leistung: string;
  readonly beginn: string;
  readonly zugangAm: string;
  readonly weg: Widerrufsweg;
  readonly email: string;
  readonly erklaerung: string | null;
  readonly bestaetigtAm: string | null;
  readonly entscheidung: 'anerkannt' | 'abgelehnt' | null;
  readonly entschiedenAm: string | null;
  readonly entscheidungsgrund: string | null;
  readonly stornovorgang: string | null;
  readonly widerrufsrecht: {
    readonly besteht: boolean | null;
    readonly fristEnde: string | null;
    readonly erloschen: boolean;
    readonly grund: string;
  };
  readonly restTageBeimZugang: number | null;
};

export async function widerrufe(alle: boolean): Promise<readonly Widerruf[]> {
  const { widerrufe: liste } = await rufe<{ readonly widerrufe: readonly Widerruf[] }>(
    `/widerrufe${alle ? '?alle=1' : ''}`,
  );
  return liste;
}

export async function erfassen(eingabe: {
  readonly buchungsnummer: string;
  readonly weg: Exclude<Widerrufsweg, 'widerrufsseite'>;
  readonly zugangAm: string;
  readonly email: string;
  readonly erklaerung: string | null;
}): Promise<{ readonly widerruf: string; readonly bestaetigt: boolean }> {
  return rufe('/widerrufe', { verfahren: 'POST', rumpf: eingabe });
}

export async function entscheiden(
  id: string,
  eingabe: { readonly anerkannt: boolean; readonly grund: string },
): Promise<{ readonly stornovorgang: string | null }> {
  return rufe(`/widerrufe/${id}/entscheidung`, { verfahren: 'POST', rumpf: eingabe });
}

/** LEG-16: null heisst am Produkt "noch nicht geklaert", am Termin "wie das Produkt". */
export async function rechtSetzen(
  wo: 'artikel' | 'termin',
  id: string,
  widerrufsrecht: 'besteht' | 'besteht_nicht' | null,
): Promise<void> {
  await rufe<void>(`/widerrufe/recht/${wo}/${id}`, { verfahren: 'PUT', rumpf: { widerrufsrecht } });
}
